import React from "react";
import { Paper, Skeleton } from "@mui/material";

const chartPaperSx = {
  p: 4,
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 2,
  boxShadow: "none",
} as const;

type DashboardChartSkeletonProps = {
  variant: "line" | "pie";
};

const DashboardChartSkeleton: React.FC<DashboardChartSkeletonProps> = ({
  variant,
}) => (
  <Paper elevation={0} sx={chartPaperSx} aria-hidden>
    <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
    {variant === "line" ? (
      <Skeleton variant="rounded" height={250} />
    ) : (
      <Skeleton
        variant="circular"
        width={200}
        height={200}
        sx={{ mx: "auto", display: "block" }}
      />
    )}
  </Paper>
);

export default DashboardChartSkeleton;
